import { InfoList } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { ProductType } from '../../types'
import { ObservationCompact } from '../../types/observation'
import {
  countAnomalyObservations,
  countEmptyAnnotationObservations,
  countNormalObservations,
  countNotAnnotatedObservations,
  countValidAnnotationObservations,
  getClassesSummary,
} from '../../utils/forms'
import { isClassificationProduct } from '../../utils/products'

interface TrainingInfoProps {
  selectedObservations: ObservationCompact[]
  productType: ProductType
  showOnlyTotal?: boolean
}

const TrainingInfo = ({
  selectedObservations,
  productType,
  showOnlyTotal = false,
}: TrainingInfoProps) => {
  const { t } = useTranslation()

  const getInfo = () => {
    if (showOnlyTotal) {
      return []
    }

    if (isClassificationProduct(productType)) {
      return getClassesSummary(selectedObservations, t).map((i) => ({
        title: i.title,
        value: i.count,
      }))
    }

    return [
      {
        title: t('Not annotated'),
        value: countNotAnnotatedObservations(selectedObservations),
      },
      {
        title: t('Empty'),
        value: countEmptyAnnotationObservations(selectedObservations),
      },
      ...(productType === 'segmentation' ||
      productType === 'classification_patch'
        ? [
            {
              title: t('Annotated'),
              value: countValidAnnotationObservations(selectedObservations),
            },
          ]
        : []),
      {
        title: t('Anomaly'),
        value: countAnomalyObservations(selectedObservations),
      },
      {
        title: t('Normal'),
        value: countNormalObservations(selectedObservations),
      },
    ].filter((item) => item.value > 0)
  }

  return (
    <InfoList
      list={[
        ...getInfo(),
        {
          title: t('Total images'),
          value: selectedObservations.length,
        },
      ]}
    />
  )
}

export default TrainingInfo
